import { render, staticRenderFns } from "./SupporterDonations.vue?vue&type=template&id=2b0cf4ab&scoped=true&"
import script from "./SupporterDonations.vue?vue&type=script&lang=js&"
export * from "./SupporterDonations.vue?vue&type=script&lang=js&"
import style0 from "./SupporterDonations.vue?vue&type=style&index=0&id=2b0cf4ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cf4ab",
  null
  
)

export default component.exports